export class IMessaging {
    messagingSenders: IMessagingSender;
    lstmessagingReceiveds: IMessagingReceived[];
    lstMessagingCC: IMessagingCC[];
    lstAttachments: IMsgattachment[];
}

export class IMessagingSender {
    RowNum: number;
    senderId: number;
    senderUserID: string;
    roleID: string;
    messageType: number;
    priority: string;
    subject: string;
    body: string;
    isDeleted: boolean;
    isVisible: boolean;
    dbOpertion: string;
    createdBy: string;
    createdOn: Date;
    messageName: string;
    imageSource: string;
    receiverUserID: string;
    receiverUserId: string;
    senderFullName: string;
    receiverFullName: string;
    amendmentId: number;
    amendmentStatus: string;
    attachmentName: string;
    attachment: any;
    listUsersTo: string;
    listUsersCC: string;
    toOrCC: string;
    patId: number;
    patName: string;
    pharmacyId: number;
    medicationId: string;
    pharmacyName: string;
    medications: string;
    recieverId: number;
    ssrId: number;
    drugDescription: string;
    pharmacy: string;
    sig: string;
    patDOB: string;
    deaStatus: string;
    encounterId: string;
    providerId: string;
    startDate: Date;
    status?: string;
    locationName:string;
}

export class IMessagingReceived {
    receiverID: number;
    senderID: number;
    listUsersTo: string;
    listUsersCC: string;
    toOrCC: string;
    roleID: string;
    receiverUserID: string;
    dbOpertion: string;
    isActive: boolean;
    isVisible: boolean;
    isDeleted: boolean;
    createdBy: string;
    createdOn: Date;
    receiverFullName: string;
    attachmentName: string;
    attachment: any;
    patName: string;
}

export class IMessagingCC {
    ccid: number;
    senderID: number;
    ccUserID: string;
    dbOpertion: string;
    isActive: boolean;
    isVisible: boolean;
    isDeleted: boolean;
    createdBy: string;
    createdOn: Date;
}

export class IMessageType {
    messageId: number;
    messageName: string;
    messageValue: string;
    path: string;
}

export class IMsgattachment {
    attId: number;
    senderID: number;
    senderUserID: string;
    recieverUserID: string;
    attachmentName: string;
    attachments: any;
    mId: number;
    attachFilePath: string;
    extension: string;
    attachmentDescription: string;
    isActive: boolean;
    dbOpertion: string;
}

export class NurseDashbord {
    senderId: number;
    status: string;
    subject: string;
}


export class patientboarddashboard {
    Appstatus: string;
}


export class NurseDashbordAttachments {
    obsInboxMessages: NurseDashbord[];
    obsInboxMessagesAttachments: patientboarddashboard[];
}

//**** Message Inbox */

export class MessageInbox {
    patientName: string;
    requestTime: string;
    requestType: string;
    requestTypeId: number;
    linkId: string;
    status: string;
    comments: string;
    createdBy: string;
    InsurancedetailsId: string;
    requestId: number;

    notes: string;
    subject: string;
    fromUser: string;
    patientNameDOB: string;
    secureMessageId: number;
}

export class messengerPatientsInfo {
    PatientId: number;
    PatientName: string;
    CellPhone: string;
    HomePhone: string;
    WorkPhone: string;
    PatAddress: string;
    MessageCount: string;
}

export class ReceiveMessengerInfo {
    patientId: number;
    patientName: string;
    smsSid: string;
    body: string;
    accountSid: string;
    from: string;
    to: string;
    fromState: string;
    fromCity: string;
    fromZip: string;
    fromCountry: string;
    isReaded: boolean;
    createdOn: Date;
    patAddress: string;
    isReadedOn: Date;
}

export class chatMessengerInfo {
    patientId: number;
    patientName: string;
    prividerId: string;
    prividerName: string;
    message: string;
    createdOn: Date;
    createdBy: string;
    from: string;
}